import type { Resource } from "@ferrivia/i18n";
import fi from "./locales/fi.json";
import en from "./locales/en.json";

export const journeyUiResources: Resource = {
  fi: { journey: fi },
  en: { journey: en },
};
